import React, { useEffect, useState } from 'react';
// material-ui

// assets
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

import {
    FormControlLabel,
    InputAdornment,
    Radio,
    RadioGroup,
    TextField,
    Typography
} from '@mui/material';
import login from 'services/Login/LoginService';
import { warningNotification } from 'utils/toastify';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import SearchIcon from '@mui/icons-material/Search';
import { useForm } from 'react-hook-form';
import { db } from 'db/db-dexie';
import Swal from 'sweetalert2';
// ==============================|| SIDEBAR MENU Card ||============================== //

const MenuCard = () => {
    const {
        register,
    } = useForm();
    const [listaRol, setListaRol] = useState([]);
    const [idRol, setIdRol] = useState();

    const [open, setOpen] = useState(false);

    const [progress, setProgress] = useState(10);
    const [route, setRoute] = useState();
    const [valid, setValid] = useState();
    const [search, setSearch] = useState('');
    useEffect(() => {
        setListaRol(JSON.parse(localStorage.getItem('roles')) || []);
        setIdRol(Number(localStorage.getItem('idRol')));
    }, []);

    const handleClick = () => {
        setOpen(!open);
    };

    const handleToggle = async (e) => {
        const value = Number(e.target.value);
        if (value === idRol) return;

        const rolActual = JSON.parse(localStorage.getItem("nombreRolTipo"));
        const sucursalActual = JSON.parse(localStorage.getItem("nombreSucursal"));
        const nuevoRolObj = listaRol.find((r) => r.idRol === value);

        if (!nuevoRolObj) return;

        Swal.fire({
            title: '¿Deseas cambiar de rol?',
            html: `Vas a cambiar de:<br>
            <b>${rolActual} - ${sucursalActual}</b><br><br>
            a:<br>
            <b>${nuevoRolObj.descripcion} - ${nuevoRolObj.sucursal}</b><br><br>
            Al cambiar de rol, el sistema actualizará tus permisos, menús y sucursal activa.`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#6fbf73',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, cambiar rol',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                await db.account.clear(); // Limpiamos data anterior      
                await db.subAccount.clear();
                await db.functions.clear();
                
                // Elimina la bd de dexie
                localStorage.setItem('go', true);
                localStorage.removeItem("PeriodoSeleccionado");

                login
                    .GetChange({ id: value })
                    .then(async (resultLogin) => {
                        if (resultLogin.code === '1') {
                            const resp = resultLogin.payload;

                            localStorage.setItem('roles', JSON.stringify(resp.roles));
                            localStorage.setItem('go', false);
                            localStorage.setItem('JWT', JSON.stringify('Bearer ' + resp.token));
                            localStorage.setItem('codigoUsuario', JSON.stringify(resp.codigoUsuario));
                            localStorage.setItem('user', JSON.stringify(resp.user));
                            localStorage.setItem('idSucursal', JSON.stringify(resp.idSucursal));
                            localStorage.setItem('nombreSucursal', JSON.stringify(resp.nombreSucursal));
                            localStorage.setItem('nombreRolTipo', JSON.stringify(resp.nombreRol));
                            localStorage.setItem('codigoRolTipo', JSON.stringify(resp.codigoRolTipo));
                            localStorage.setItem('ambiente', JSON.stringify(resp.ambiente));
                            localStorage.setItem('idRol', JSON.stringify(resp.idRol));
                            localStorage.setItem('idUsuario', JSON.stringify(resp.idUsuario));
                            localStorage.setItem('hour', JSON.stringify(3));
                            localStorage.setItem('minute', JSON.stringify(54));
                            localStorage.setItem('second', JSON.stringify(59));
                            localStorage.setItem('config', false);
                            localStorage.removeItem('cachedSucursalId');

                            // Limpiar datos contables de la sucursal anterior inmediatamente
                            try {
                                await db.account.clear();
                                await db.subAccount.clear();
                                await db.functions.clear();
                            } catch (e) {
                                console.warn('Error limpiando IndexedDB al cambiar rol:', e);
                            }

                            Swal.fire({
                                title: '¡Completado!',
                                text: `Rol actualizado correctamente. Ahora estás trabajando como ${resp.nombreRol} en ${resp.nombreSucursal}.`,
                                icon: 'success',
                                confirmButtonColor: '#6fbf73'
                            }).then(() => {
                                startSesion(resultLogin.redirectTo, login.verifyLogin());
                            });
                        } else {
                            warningNotification(resultLogin.message);
                        }
                    })
                    .catch((error) => { 
                        warningNotification("No se pudo cambiar el rol. Intenta nuevamente.");
                        console.log(error);
                    });
            }
        });
    };

    const startSesion = (ruta, valor) => {
        if (!valor) {
            window.location.href = ruta;
            // setLoading((prevLoading) => !prevLoading)
            window.location.reload();
        }
    };

    // const cargando = () => {
    //     const timer = setInterval(() => {
    //         setProgress((prevProgress) => (prevProgress >= 100 ? 0 : prevProgress + 10));

    //     }, 800);

    //     return () => {
    //         clearInterval(timer);
    //     };

    // }

    // useEffect(() => {

    //     if (progress == 100)
    //         startSesion(route, valid);
    // }, [progress])
    const requestSearch = (e) => {
        const value = e.target.value;
        setSearch(value);
    };
    const results = !search ? listaRol : listaRol.filter((dato) => dato.sucursal.toLowerCase().includes(search.toLocaleLowerCase()));

    return (
        <>
            {/* <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}

            >

                <CircularProgress size="300px" color="inherit" variant='determinate' value={progress} />
                <Box
                    sx={{
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 0,
                        position: 'absolute',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}

                >
                    <Typography variant="h3" gutterBottom >
                        {`${Math.round(progress)}%`}
                    </Typography>

                </Box>
            </Backdrop> */}
            <List
                //   sx={{
                //     width: '100%',
                //     maxWidth: 360,
                //     bgcolor: 'background.paper',
                //     position: 'relative',
                //     overflow: 'auto',
                //     maxHeight: 300,
                //     '& ul': { padding: 0 },
                //   }}
                sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
                component="nav"
                aria-labelledby="nested-list-subheader"
            // component="div"
            >
                <ListItemButton onClick={handleClick}>
                    <ListItemIcon>
                        <SupervisedUserCircleIcon />
                    </ListItemIcon>
                    <ListItemText primary="Roles" />
                    {open ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
                </ListItemButton>
                <Collapse in={open} timeout="auto" unmountOnExit>

                    {listaRol.length > 1 ? (<>
                        <br></br>
                        <TextField
                            {...register('sucursal')}
                            onChange={(e) => requestSearch(e)}
                            style={{ width: '100%' }}
                            size="small"
                            id="outlined-basic"
                            label="Sucursal"
                            variant="outlined"
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <SearchIcon fontSize="small" />
                                    </InputAdornment>
                                ),
                                style: { height: 25, fontSize: 12 }
                            }}
                            InputLabelProps={{ shrink: true }}
                        /></>
                    ) : (
                        ''
                    )}

                    <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        value={idRol}
                        name="radio-buttons-group"
                        onChange={(e) => handleToggle(e)}
                    >
                        {results.map((row, index) => (
                            <FormControlLabel
                                key={index + 1}
                                value={row.idRol}
                                control={<Radio size="small" />}
                                label={
                                    <div>
                                        <Typography variant="button" display="block">
                                            <small> {row.sucursal}</small>
                                        </Typography>
                                        <Typography variant="subtitle2">
                                            <small>{row.descripcion}</small>
                                        </Typography>
                                    </div>
                                }
                            />
                        ))}
                    </RadioGroup>
                </Collapse>
            </List>
        </>
    );
};

export default MenuCard;
